import { getCalculatedTotal, getSelectedQuoteOption } from '../../components/smartsend/generateProtectionKey';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { AddPreferredCollectionDate } from './AddPreferredCollectionDate';
import { chunk, SumNumber } from './ArrayHelper';
import { ProviderGroup } from './SmartSendBulkActionApplier';
import { SmartSendProvider } from '~/lib/consts/providers';

export function GetItemsByProvider(items: SmartSendItemApiModel[], batchSize: number): ProviderGroup[] {
  let output: ProviderGroup[] = [];

  // Force a date
  items.forEach(AddPreferredCollectionDate);

  items.forEach((element) => {
    if (
      !output.find(
        (x) => x.Provider.Provider === element.Service.Provider && x.Provider.AccountId === element.Service.AccountId
      )
    ) {
      output.push({
        Key: `${element.Service.Provider}:0`,
        Provider: {
          AccountId: element.Service.AccountId || SmartSendProvider,
          Provider: element.Service.Provider || SmartSendProvider
        },
        Items: [],
        TotalPriceExVat: 0,
        Duties: 0,
        TotalPrice: 0,
        TotalVat: 0,
        VatRate: 0,
        SelectedPaymentMethod: 'External',
        State: 'IDLE',
        Summary: [],
        MarkedAsDispatched: false,
        Manifestable: false,
        Discount: { Applied: false },
        Links: [],
        CurrencyCode: element.State?.validation?.QuoteState?.Quote?.CurrencyCode ?? element.CurrencyCode
      });
    }
  });

  // Store additional items.
  const additionalOptions: ProviderGroup[] = [];

  // Loop the Providers and split out based on limits
  output.forEach((o) => {
    const chunked = chunk(
      items.filter((x) => x.Service.Provider === o.Provider.Provider && x.Service.AccountId === o.Provider.AccountId),
      batchSize
    );
    chunked.forEach((c, i) => {
      if (i === 0) {
        o.Items = c;
        o.Key = `${o.Provider.Provider}_${o.Provider.AccountId}_${c.length}:${i}`;
      } else {
        const additional: ProviderGroup = JSON.parse(JSON.stringify(o));
        additional.Items = c;
        additional.Key = `${o.Provider.Provider}_${o.Provider.AccountId}_${c.length}:${i}`;
        additionalOptions.push(additional);
      }
    });
  });

  // Join List
  output = output.concat(additionalOptions);

  output.forEach((o) => {
    // Loop the Provider Items and spit by service
    o.Items.forEach((i) => {
      if (!o.Summary.find((s) => s.Service.Id === i.Service.Id)) {
        o.Summary.push({
          Service: i.Service,
          Count: 0,
          TotalPriceExVat: 0,
          TotalPrice: 0,
          TotalVat: 0,
          VatRate: 0,
          Duties: 0,
          CurrencyCode: i.State?.validation?.QuoteState?.Quote?.CurrencyCode ?? i.CurrencyCode
        });
        // Terms Links
        i?.State?.validation?.QuoteState?.Quote?.Service?.Links?.filter((l) => l.Type?.startsWith('TERMS:')).forEach(
          (ll) => {
            if (ll.Type && !o.Links.some((l) => l.Type === ll.Type)) {
              o.Links.push(ll);
            }
          }
        );
      }
    });

    o.Summary.forEach((s) => {
      const sumItems = o.Items.filter((x) => x.Service.Id === s.Service.Id);
      s.Count = sumItems.length;

      sumItems.forEach((i) => {
        const q = getCalculatedTotal(getSelectedQuoteOption(i, i.State.validation.QuoteState.Quote));
        if (q) {
          s.TotalPriceExVat += q.TotalPriceExVat;
          s.TotalPrice += q.TotalPrice;
          s.Duties += q.Duties;
          s.TotalVat += q.TotalVat;
        }
      });
    });

    o.TotalPrice = SumNumber(o.Summary.map((x) => x.TotalPrice));
    o.TotalPriceExVat = SumNumber(o.Summary.map((x) => x.TotalPriceExVat));
    o.Duties = SumNumber(o.Summary.map((x) => x.Duties));
    o.TotalVat = SumNumber(o.Summary.map((x) => x.TotalVat));
    o.Manifestable = !!o.Items.find((x) => x?.State?.validation?.QuoteState?.Quote?.Service?.RequiresManifest === true);
  });

  return output;
}
